module.exports = __webpack_public_path__ + "static/media/Folks-Normal.9c8b499a.ttf";